import { render, staticRenderFns } from "./DefectLogs.vue?vue&type=template&id=48de9f3f&scoped=true&"
import script from "./DefectLogs.vue?vue&type=script&lang=js&"
export * from "./DefectLogs.vue?vue&type=script&lang=js&"
import style0 from "./DefectLogs.vue?vue&type=style&index=0&id=48de9f3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48de9f3f",
  null
  
)

export default component.exports